function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-three-step-cta\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9,27.19H15.1a1.13,1.13,0,1,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9,32.23H15.1a1.13,1.13,0,1,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7,27.19H28.9a1.13,1.13,0,0,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7,32.23H28.9a1.13,1.13,0,0,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1,27.19H1.3a1.13,1.13,0,1,1,0-2.25h9.8a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1,32.23H1.3A1.13,1.13,0,1,1,1.3,30h9.8a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.61,20.83H16.39A2.43,2.43,0,0,1,14,18.41V8.65a2.42,2.42,0,0,1,2.42-2.41h7.22A2.42,2.42,0,0,1,26,8.65v9.76A2.43,2.43,0,0,1,23.61,20.83ZM16.39,8.49a.17.17,0,0,0-.17.16v9.76a.18.18,0,0,0,.17.17h7.22a.18.18,0,0,0,.17-.17V8.65a.17.17,0,0,0-.17-.16Z",
  fill: "#231f20"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81,20.83H2.59A2.43,2.43,0,0,1,.17,18.41V8.65A2.42,2.42,0,0,1,2.59,6.24H9.81a2.41,2.41,0,0,1,2.41,2.41v9.76A2.42,2.42,0,0,1,9.81,20.83ZM2.59,8.49a.17.17,0,0,0-.17.16v9.76a.18.18,0,0,0,.17.17H9.81a.17.17,0,0,0,.16-.17V8.65a.16.16,0,0,0-.16-.16Z",
  fill: "#231f20"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M37.41,20.83H30.19a2.42,2.42,0,0,1-2.41-2.42V8.65a2.41,2.41,0,0,1,2.41-2.41h7.22a2.42,2.42,0,0,1,2.42,2.41v9.76A2.43,2.43,0,0,1,37.41,20.83ZM30.19,8.49a.16.16,0,0,0-.16.16v9.76a.17.17,0,0,0,.16.17h7.22a.18.18,0,0,0,.17-.17V8.65a.17.17,0,0,0-.17-.16Z",
  fill: "#231f20"
});

function SvgCmsThreeStepCta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgCmsThreeStepCta;